module.exports = __webpack_public_path__ + "8f5c20228d8de558c77ab74dd8a429b5.png";